module.exports = __webpack_public_path__ + "img/img_work_injury_large.f33da2dc.jpg";